import ngoProfileService from "../../services";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    loading: false,
    creationInfo: {},
    deletingDoc: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    deletingDoc(state) {
      return state.deletingDoc;
    },
  },
  mutations: {
    setLoading(state, payload) {
      state.loading = payload;
    },
    setDeletingDoc(state, payload) {
      state.deletingDoc = payload;
    },
  },
  actions: {
    async deleteDoc({ commit, dispatch }, doc) {
      commit("setDeletingDoc", true);
      try {
        const res = await ngoProfileService.deleteDoc(doc.key);
        commit("setDeletingDoc", false);
        if (!res.status) {
          return Promise.reject(res);
        } else {
          await dispatch("NgoProfile/fetchNgoData", {}, { root: true });
          return Promise.resolve(res);
        }
      } catch (err) {
        commit("setDeletingDoc", false);
        return Promise.reject(err);
      } finally {
        commit("setDeletingDoc", false);
      }
    },
    async editHq({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await ngoProfileService.updateHqInfo(payload);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم تعديل المعلومات بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        await dispatch("NgoProfile/fetchNgoData", {}, { root: true });
        commit("setLoading", false);
        return Promise.resolve(res);
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل المعلومات",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        commit("setLoading", false);
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },
    async editNgoData({ commit, dispatch }, payload) {
      commit("setLoading", true);
      try {
        const res = await ngoProfileService.updateNgoInfo(payload);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم تعديل المعلومات بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });

        await dispatch("NgoProfile/fetchNgoData", {}, { root: true });
        commit("setLoading", false);
        return Promise.resolve(res);
      } catch (err) {
        commit("setLoading", false);
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تعديل المعلومات",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return Promise.reject(err);
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
